export const imgAltar = {
    src: 'images/altar.jpg',
    alt: 'Altar principal da igreja Madre de Deus de Angustura',
    text: 'Altar principal da igreja Madre de Deus de Angustura'
};

export const imgCruz = {
    src: 'images/cruz.jpg',
    alt: 'Cruz em frente à igreja',
    text: 'Cruz em frente à igreja'
};

export const imgFront = {
    src: 'images/front.jpg',
    alt: 'Fachada da igreja Madre de Deus de Angustura',
    text: 'Fachada da igreja Madre de Deus de Angustura'
};

export const imgNoite = {
    src: 'images/noite.jpg',
    alt: 'Imagem de Nossa Senhora de Lourdes da Gruta de Lourdes',
    text: 'Imagem de Nossa Senhora de Lourdes, na gruta'
};

export const imgPlaca = {
    src: 'images/placa.jpg',
    alt: 'Placa na gruta',
    text: 'Letreiro'
};

export const imgRosa = {
    src: 'images/rosa.jpg',
    alt: 'Gruta de Lourdes',
    text: 'Gruta de Lourdes, datada de 1935'
};

export const imgTumulo = {
    src: 'images/tumulo.jpg',
    alt: 'Tumulo da Brigida',
    text: 'Túmulo da Brígida, cemitério de Angustura'
};